import type { ComponentType } from '@grafikr/components';
import fastdom from 'fastdom';

const Component: ComponentType = (node) => {
  const parent = node.parentElement;

  const menuItems = node.querySelectorAll('[data-menu-items]');

  let lastScrollPosition = window.scrollY;
  let job: () => void;

  const mouseOverHandler = () => {
    parent.classList.remove('transparent-header');
    menuItems.forEach((item) => {
      item.classList.remove('opacity-0');
    });
  };

  const mouseOutHandler = () => {
    parent.classList.add('transparent-header');
  };

  if (parent.getAttribute('data-transparent')) {
    parent.addEventListener('mouseover', mouseOverHandler);
    parent.addEventListener('mouseout', mouseOutHandler);
  }

  const announcementBar = document.getElementById('header-announcement');

  const headerHeight = () => {
    if (announcementBar) {
      if (announcementBar.getBoundingClientRect().bottom > 0) {
        node.parentElement.style.setProperty(
          'top',
          `${Math.max(announcementBar.getBoundingClientRect().bottom, 0)}px`,
        );
      } else {
        node.parentElement.style.setProperty('top', `${Math.max(0, 0)}px`);
      }
    }
  };

  headerHeight();

  const scrollEvent = () => {
    if (job) {
      fastdom.clear(job);
    }

    job = fastdom.mutate(() => {
      if (window.scrollY > lastScrollPosition && parent.getAttribute('data-transparent')) {
        parent.classList.add('transparent-header');
        menuItems.forEach((item) => {
          item.classList.add('opacity-0');
        });
      } else {
        menuItems.forEach((item) => {
          item.classList.remove('opacity-0');
        });
      }

      headerHeight();

      lastScrollPosition = window.scrollY;
    });
  };

  window.addEventListener('scroll', scrollEvent, {
    passive: true,
  });
};

export default Component;
